import type { ThreeElements } from '@react-three/fiber'
import { poseFerramentaManual, type FerramentaManualAnimada } from './animacaoFerramentaManual'
import { BarraHalligan3D } from './BarraHalligan3D'
import { PuncaoHolmatro3D } from './PuncaoHolmatro3D'

interface Props extends Omit<ThreeElements['group'], 'children'> {
  ferramenta: FerramentaManualAnimada
  progresso: number
  ativa?: boolean
}

export function FerramentaManual3D({ ferramenta, progresso, ativa = false, ...props }: Props) {
  const pose = poseFerramentaManual(ferramenta, progresso)
  if (ferramenta === 'hooligan') {
    return (
      <group {...props}>
        {/* Pivô na ponta da cunha (x = +0.72 m) que entra e encaixa na fresta da fechadura */}
        <group position={[0.72, 0, 0]} rotation={[pose.giroTorcao ?? 0, 0, pose.rotacaoAlavanca]}>
          <group position={[-0.72 + (pose.deslocamentoInsercao ?? 0), 0, 0]}>
            <BarraHalligan3D ativa={ativa} />
          </group>
        </group>
      </group>
    )
  }

  return (
    <group {...props}>
      <PuncaoHolmatro3D progresso={progresso} ativa={ativa} />
    </group>
  )
}
